import UserComment from "./UserComment";
import { IUserReplyProps } from "@/interfaces/activityFeed";
import "../../../../../css/activityFeed/elements/user-reply.scss";



const UserReply = ({zIndexNum, className, originalText, replyText, truncateNumber, getOpenOnWebLink, onLikeClick, isLiked, onDeleteCommentClick, hideMenu}: IUserReplyProps) => {

    return (
        <div className={`user-reply-wrapper ${className ?? ""}`} style={zIndexNum !== undefined ? { zIndex: zIndexNum } : undefined}>
            <UserComment commentText={originalText} isOriginalComment truncateNumber={((truncateNumber / 2) - 6)}/>
            
            <div className="comment-connector" />
            <div className="hidden-panel" />
            
            <UserComment commentText={replyText} isReply truncateNumber={truncateNumber} onLikeClick={onLikeClick} isLiked={isLiked} getWebLink={getOpenOnWebLink} onDeleteClick={onDeleteCommentClick} hideMenu={hideMenu}/>
        </div>
    );
};

export default UserReply